import { createFileRoute } from '@tanstack/react-router';
import { TrustLayout } from '../../components/trust/TrustLayout';

export const Route = createFileRoute('/trust/architecture')({
  component: ArchitecturePage,
});

function ArchitecturePage() {
  return (
    <TrustLayout>
      <h1 className="mt-0 text-[22px] text-black">Architecture</h1>
      <p className="max-w-[720px] text-black leading-relaxed">
        Repancy is a single-page app in your browser. It talks to your Microsoft
        365 tenant directly via MSAL (the Microsoft Authentication Library) — we
        never proxy your credentials through our servers.
      </p>
      <pre
        data-testid="trust-architecture-diagram"
        className="overflow-x-auto bg-white border border-black/20 p-4 text-xs text-black font-mono"
      >
{`┌─────────────────────── Browser (Repancy SPA) ──────────────────────┐
│                                                                    │
│   ① MSAL popup — your Microsoft account                            │
│                  │                                                 │
│                  │ id+access tokens                                │
│                  ▼                                                 │
│   ② Microsoft Graph (graph.microsoft.com)                          │
│      - /sites, /drives, /items, /delta                             │
│      - PUT content with If-Match etag                              │
│                                                                    │
│   ③ Convex (industrious-ibex-275.convex.cloud)                     │
│      - Stores: matter ↔ document links, audit log, sync cursor     │
│      - Never stores: your raw file content beyond cache TTL        │
│      - Never stores: your Microsoft refresh token                  │
│                                                                    │
└────────────────────────────────────────────────────────────────────┘`}
      </pre>
      <p className="max-w-[720px] text-black leading-relaxed">
        <strong>What this means in plain terms:</strong> your file content lives in your
        SharePoint tenant. Repancy stores only the link (siteId, driveId, itemId,
        webUrl, etag) plus enough metadata to know which matter it belongs to.
        When you preview or edit, your browser fetches directly from Graph using
        your token.
      </p>
    </TrustLayout>
  );
}
